module.exports = __webpack_public_path__ + "img/schema_otn_3a.6c423dca.svg";